import { CityTotalEventsType } from 'components/@events/types';

export const CityToEventsTotal = ({
  meta,
}: {
  meta: { count: number };
}): CityTotalEventsType => {
  const eventCount = meta.count;
  return { upcomingEvents: eventCount };
};
